<template>
  <List
    title="profiles"
    resource="profiles"
    :basePath="basePath"
    :fields="fields"
    ref="list"
    :initial-filter="{ deletedEntity: 'all' }"
    :search="true"
    search-placeholder="Search for a profile by id, leaseId, membershipId"
    track-by="id"
    on-row-click="details"
    :filter-mapper="mapFilterToQuery"
    data-provider="$raaDataProvider"
  >
    <template v-slot:filters="filterScope">
      <div class="form-row">
        <SelectInput
          name="deletedEntity"
          :label="entityFilterName"
          :options="entityFilterOptions"
          no-clear
        />
        <SelectInput name="personId" label="person" :options="persons" />
      </div>
      <div class="form-row">
        <div class="form-col flex items-end justify-end">
          <button @click.stop="filterScope.reset()" class="btn-primary btn-transparent mr-8">Reset</button>
          <button class="btn-primary">Filter</button>
        </div>
      </div>
    </template>
    <template v-slot:inline-actions="actionsScope">
      <button
        class="btn-action-warning focus:outline-none"
        v-if="!actionsScope.record.deletedAt"
        @click.stop="deleteProfile(actionsScope.record)"
      >
        <icon class="w-5 h-5 mr-1" name="trash"/>
      </button>
      </template>
  </List>
</template>

<script>
  import ModalNavigation from "@/mixins/ModalNavigation";
  import ConfirmationMixin from "@/mixins/ConfirmationMixin";
  import NotifyMixin from "@/mixins/NotifyMixin";
  import SelectInput from "@/components/form/SelectInput";
  import List from "@/components/auth/list/List";
  import UserField from '@/components/auth/list/fields/UserField';
  import DateTimeField from '@/components/auth/list/fields/DateTimeField';
  import EntityFilterMixin from "@/components/auth/EntityFilterMixin";
  import ProfilesMixin from "./ProfilesMixin";
  import Icon from "@/components/ui/Icon";

  export default {
    name: "ProfilesList",
    components: {
      List,
      SelectInput,
      Icon,
    },
    mixins: [ModalNavigation, ConfirmationMixin, EntityFilterMixin, NotifyMixin, ProfilesMixin],
    computed: {
      basePath: function () {
        return this.$route.path;
      },
    },
    data: function () {
      return {
        fields: [
          {
            name: UserField,
            title: 'person',
            sortField: 'fullName',
            switch: {
              getEmail: ({ emails = [] }) => emails[0]?.email
            }
          },
          {
            name: 'relationshipType',
            title: 'relationship',
            sortField: 'relationshipTypeName',
          },
          {
            name: 'communityName',
            title: 'community',
            sortField: 'communityName',
          },
          {
            name: DateTimeField,
            sortField: 'createdAt',
            title: 'registered',
            switch: {
              source: 'createdAt'
            },
            titleClass: 'text-center',
            dataClass: 'text-center',
          },
          {
            name: 'inline-actions',
            title: '',
          }
        ],
        filter: {},
      }
    },
    created() {
      Promise.all([
        this.fetchLeases(),
        this.fetchMemberships(),
        this.fetchPersons()
      ]);
    },
    methods: {
      mapFilterToQuery({ deletedEntity, ...rest } = {}) {
        const deletedFilter = this.mapEntityFilterToQuery(deletedEntity);
        return {
          ...rest,
          ...deletedFilter,
        };
      },
      deleteProfile(record) {
        this.requestConfirmation({
          confirmationMessage: 'Are you sure you want to delete this profile?',
          confirmBtnText: 'yes',
          cancelBtnText: 'no',
          confirmationType: 'warning'
        })
          .then(confirmed => confirmed
            ? this.$raaDataProvider.delete('profiles', { id: record.id })
              .then(() => {
                this.$refs.list.doSearch();
                this.notifySuccess('Profile deleted');
              })
              .catch(error => this.notifyError(error.message))
            : null
          );
      },
    }
  }
</script>

<style scoped>

</style>
